import api from './api';
import { Prize } from '../types';

// Função utilitária para normalizar dados de prêmio
const normalizePrize = (prize: any): Prize => ({
  ...prize,
  campaignId: prize.campaignId || prize.campaign?.id || '',
});

// Função utilitária para normalizar array de prêmios
const normalizePrizes = (prizes: any[]): Prize[] => 
  prizes.map(normalizePrize);

export const prizeService = {
  async getAllPrizes(): Promise<Prize[]> {
    const response = await api.get('/prizes');
    return normalizePrizes(response.data);
  },

  async getPrizeById(id: string): Promise<Prize> {
    const response = await api.get(`/prizes/${id}`);
    return normalizePrize(response.data);
  },

  async createPrize(prize: Omit<Prize, 'id' | 'createdAt' | 'updatedAt'>): Promise<Prize> {
    const response = await api.post('/prizes', prize);
    return normalizePrize(response.data);
  },

  async updatePrize(id: string, prize: Partial<Prize>): Promise<Prize> {
    const response = await api.put(`/prizes/${id}`, prize);
    return normalizePrize(response.data);
  },

  async deletePrize(id: string): Promise<void> {
    await api.delete(`/prizes/${id}`);
  },

  async getPrizesByCampaign(campaignId: string): Promise<Prize[]> {
    const response = await api.get(`/prizes/campaign/${campaignId}`);
    return normalizePrizes(response.data);
  }
}; 